import React, { useMemo } from 'react';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import PropTypes from 'prop-types';
import { ResponsiveContainer } from 'recharts';
import { Container, Main, Wrapper } from './styles';
import StaticRechartsLine from './StaticRechartsLine';
import MarkerChart from './MarkerChart';
import { toTimestamp } from './common';

// Компонент графика сенсора с линией и маркером выбранной даты
function SensorChart({ sensorName, data, selectedDate, onDelete, thresholds, domain }) {
  const chartData = useMemo(() => {
    if (!Array.isArray(data)) return [];

    return data
      .map((item) => {
        if (!item?.createdDate) return null;

        const date = toTimestamp(item.createdDate);
        if (!date) return null;

        return {
          value: item.value,
          timestamp: date,
        };
      })
      .filter(Boolean);
  }, [data]);

  const hasChartData = !!chartData.length;

  return (
    <Main>
      <Container>
        <ResponsiveContainer width="100%" height="100%">
          <StaticRechartsLine chartData={chartData} sensorName={sensorName} thresholds={thresholds} domain={domain} />
        </ResponsiveContainer>

        {hasChartData && (
          <Wrapper>
            <ResponsiveContainer width="100%" height="100%">
              <MarkerChart chartData={chartData} selectedDate={selectedDate} domain={domain} />
            </ResponsiveContainer>
          </Wrapper>
        )}
      </Container>

      {!!onDelete && (
        <IconButton
          className="delete-btn"
          title="Удалить"
          onClick={onDelete}
          sx={{
            opacity: 0,
            transition: 'opacity 0.2s ease',
          }}
        >
          <DeleteIcon />
        </IconButton>
      )}
    </Main>
  );
}

SensorChart.propTypes = {
  sensorName: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      createdDate: PropTypes.string,
    }),
  ),
  selectedDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  onDelete: PropTypes.func,
  thresholds: PropTypes.shape({
    lowWarning: PropTypes.number,
    highWarning: PropTypes.number,
    lowError: PropTypes.number,
    highError: PropTypes.number,
    warningEnabled: PropTypes.bool,
    errorEnabled: PropTypes.bool,
  }),
  domain: PropTypes.arrayOf(PropTypes.number),
};

SensorChart.defaultProps = {
  data: [],
  selectedDate: null,
  onDelete: null,
  thresholds: null,
  domain: undefined,
};
export default React.memo(SensorChart);
